import { getApi, postApi, putApi } from "./api_instance";

export const getBankDetails = async (logout) => {
  try {
    const response = await getApi({
      apiUrl: `/admin/api/bankAccount/details/admin/all-accounts`,
      sendToken: true,
      logout,
    });
    return response;
  } catch (error) {
    throw error;
  }
};

export const createBankDetails = async (bankData, logout) => {
  try {
    const { data } = await postApi({
      apiUrl: `/admin/api/bankAccount/add-account`,
      data: bankData,
      sendToken: true,
      logout,
    });
    return data;
  } catch (error) {
    throw error;
  }
};

export const updateBankDetails = async (accountId, bankData, logout) => {
  try {
    const { data } = await putApi({
      apiUrl: `/admin/api/bankAccount/update-account/${accountId}`,
      data: bankData,
      sendToken: true,
      logout,
    });
    return data;
  } catch (error) {
    throw error;
  }
};


export const getAllRegistries = async (logout) => {
  try {
    return await getApi({
      apiUrl: "/projects/api/registry/getAllRegistires",
      logout,
    });
  } catch (error) {
    throw error;
  }
};


export const createRegistryDetails = async ({id,registryData}, logout) => {
  try {
    const { data } = await postApi({
      apiUrl: `/admin/projects/api/registry?id=${id}`,
      data: registryData,
      sendToken: true,
      logout,
    });
    return data;
  } catch (error) {
    throw error;
  }
};

export const updateRegistryDetails = async (registryID, registryData, logout) => {
  try {
    const { data } = await putApi({
      apiUrl: `/admin/projects/api/registry/${registryID}`,
      data: registryData,
      sendToken: true,
      logout,
    });
    return data;
  } catch (error) {
    throw error;
  }
};
